import React from "react";
import { Col, Container, Row } from "reactstrap";

import Section from "./Section";

import DashboardContent from "./CourierDashboard";

const Dashboard = () => {
  document.title = 'Dashboard | StarMarket';
  return (
    <React.Fragment>
      {/* <Section /> */}
      <section className="section gaps bg-light" style={{ paddingTop: "80px" }}>
        <Container fluid>
          {/* <SidebarLayout/> */}

          <DashboardContent />
        </Container>
      </section>
    </React.Fragment>
  );
};

export default Dashboard;
